import { Alert } from '@zorro/design-system/v2/Alert';
import { Stack, Text } from '@zorro/web/design-system';

type AttributeAlertProps = {
  items: string[];
  label: string;
};

export const RosterInfoAlert = ({ items, label }: AttributeAlertProps) => (
  <>
    <Alert
      variant="general-note"
      role="note"
      mb="md"
      title="Coming from another CHOICE Arrangement vendor?"
    >
      If the company had a CHOICE Arrangement with a different vendor last year,
      add each employee&apos;s Current Plan ID (the standard HIOS plan ID) and
      Current Plan Market (on or off exchange). This lets employees see their
      current plan while shopping, and lets Zorro submit their applications to
      the carrier correctly.
    </Alert>
    {items.length > 0 && (
      <Alert variant="general-note" role="note" mb="md">
        <Stack gap="xs" style={{ flex: 1 }}>
          <Text inherit letterSpacing="inherit">
            Please use one of the exact {label} supported by the company&apos;s
            allowance model:
          </Text>
          <Text inherit letterSpacing="inherit" fs="italic">
            {items.map((cls) => `"${cls}"`).join('; ')}
          </Text>
        </Stack>
      </Alert>
    )}
  </>
);
